import { Contest } from 'types/contest/Contest'
import { GET, PUT } from 'utils/httpUtils'

const EXPORT_DATABASE_PATH = '/contest/admin/exportContests'

type AdminContest = {
  ID: number
  'DATA CRIACAO': string
  REQUERENTE: string
  REQUERIDA: string
  SERVIÇO: string
  CENÁRIO: string
  CATEGORIA: string
  STATUS: string
  ABERTURA: string
  RESPOSTA: string
  REPLICA: string
  TREPLICA: string
  DESISTIDA: string
  REENVIADA: string
  'ACEITA EM': string
  'ACORDO ENVIADO': string
}

export async function exportContests(): Promise<AdminContest[]> {
  try {
    const data = await GET<AdminContest[]>(EXPORT_DATABASE_PATH)
    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function approveContestPayment(contestId: number): Promise<Contest> {
  try {
    const data = await PUT<any, Contest>(`/contest/update/${contestId}`, {
      "action": "PAYMENT_ACCEPT",
      data: {}
    })
    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}
